<template>
    <div class="course-detail-page">
        <div v-if="detail" class="detail-container">
            <section class="player-card">
                <div class="video-main">
                    <div class="video-wrap">
                        <video
                            class="course-video"
                            :src="detail.courseLinks || ''"
                            :poster="detail.cover || ''"
                            controls
                            preload="metadata"
                            webkit-playsinline="true"
                            playsinline="true"
                            @ended="onPlayerEnded"
                        ></video>
                    </div>
                </div>
            </section>

            <div class="content">
                <section class="info-card">
                    <div class="info-top">
                        <span
                            :class="['course-tag', detail.compulsory ? 'required' : 'elective']"
                        >
                            {{ detail.compulsory ? '必修' : '选修' }}
                        </span>
                        <h1 class="course-title">{{ detail.title }}</h1>
                    </div>
                    <div class="meta-row">
                        <span class="meta-item">主讲人 {{ detail.lecturer || '-' }}</span>
                        <span class="meta-item">{{ detail.createTime || '-' }}</span>
                        <span
                            :class="['read-tag', detail.isTrain === '已培训' ? 'read' : 'unread']"
                        >
                            <img class="tag-icon" :src="seeIcon" alt="">
                            <span class="tag-text">{{ detail.isTrain || '未培训' }}</span>
                        </span>
                    </div>
                </section>

                <section class="intro-card">
                    <div class="intro-title-wrap">
                        <span class="intro-title">课程简介</span>
                    </div>
                    <div class="intro-content" v-html="detail.introduce || '-'"></div>
                </section>
            </div>
        </div>

        <div v-else class="empty-wrap">
            <van-empty description="暂无课程详情" />
        </div>
    </div>
</template>

<script>
import { finishedTrain, getCourseInfo } from '@/api/index.js';

export default {
    name: 'CourseDetail',
    data() {
        return {
            detail: null,
            finishLoading: false,
            seeIcon: require('@/assets/image/see-icon.png')
        };
    },
    created() {
        this.loadDetail();
    },
    methods: {
        getRouteId() {
            return this.$route.query.id || this.$route.params.id || '';
        },
        loadDetail() {
            const id = this.getRouteId();
            if (!id) {
                this.$router.replace({ name: 'course' });
                return;
            }
            getCourseInfo(id)
                .then(res => {
                    const data = res && res.data;
                    if (!data) {
                        this.$router.replace({ name: 'course' });
                        return;
                    }
                    this.detail = data;
                })
                .catch(() => {
                    this.$router.replace({ name: 'course' });
                });
        },
        onPlayerEnded() {
            this.$dialog
                .alert({
                    title: '提示',
                    message: '培训已完成'
                })
                .then(() => {
                    const courseId = this.detail && this.detail.id;
                    if (!courseId || this.finishLoading) return;
                    if (this.detail.isTrain === '已培训') return;
                    this.finishLoading = true;
                    this.$toast.loading({
                        message: '记录中',
                        forbidClick: true,
                        duration: 0
                    });
                    finishedTrain(courseId)
                        .then(() => {
                            this.$toast.clear();
                            this.$toast('培训成功');
                            this.detail = {
                                ...this.detail,
                                isTrain: '已培训'
                            };
                        })
                        .catch(() => {
                            this.$toast.clear();
                        })
                        .finally(() => {
                            this.finishLoading = false;
                        });
                });
        }
    }
};
</script>

<style scoped lang="scss">
.course-detail-page {
    min-height: 100%;
    background: #eef4f5;
    box-sizing: border-box;
}

.detail-container {
    max-width: 720px;
    margin: 0 auto;
}

.player-card {
    background: #fff;
    overflow: hidden;
}

.video-main {
    position: relative;
}

.video-wrap {
    position: relative;
}

.course-video {
    display: block;
    width: 100%;
    max-height: 240px;
    background: #000;
}

.content{
    padding: 12px;
}
.info-card {
    background: #fff;
    padding: 12px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
}

.info-top {
    display: flex;
    align-items: flex-start;
    gap: 8px;
}

.course-tag {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 40px;
    padding: 0 6px;
    height: 20px;
    border-radius: 3px;
    font-size: 11px;
    color: #fff;
    flex-shrink: 0;
}

.course-tag.required {
    background: #ff7a00;
}

.course-tag.elective {
    background: #5a6fd8;
}

.course-title {
    margin: 0;
    font-size: 16px;
    line-height: 1.4;
    color: #333;
    font-weight: 700;
}

.meta-row {
    margin-top: 10px;
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

.meta-item {
    font-size: 12px;
    color: #9c9c9c;
}

.read-tag {
    margin-left: auto;
    display: inline-flex;
    align-items: center;
    height: 24px;
    border-radius: 4px;
    overflow: hidden;
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

.read-tag.read {
    background-image: url('~@/assets/image/read-icon.png');
}

.read-tag.unread {
    background-image: url('~@/assets/image/unread-icon.png');
}

.tag-icon {
    width: 24px;
    height: 24px;
    padding: 5px;
    box-sizing: border-box;
    object-fit: contain;
    flex-shrink: 0;
}

.tag-text {
    padding: 0 8px;
    font-size: 12px;
    line-height: 24px;
    font-weight: 500;
}

.read .tag-text {
    color: #46CCDC;
}

.unread .tag-text {
    color: #FF7A00;
}

.intro-card {
    margin-top: 12px;
    background: #fff;
    border-radius: 12px;
    padding: 12px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
}

.intro-title-wrap {
    text-align: center;
    margin-bottom: 10px;
}

.intro-title {
    display: inline-block;
    padding: 4px 14px;
    border-radius: 12px;
    background: linear-gradient(135deg, #6fd9df, #49bfd0);
    color: #fff;
    font-size: 13px;
}

.intro-content {
    font-size: 14px;
    line-height: 1.7;
    color: #666;
    word-break: break-word;
}

.intro-content ::v-deep p {
    margin: 0 0 10px;
}

.empty-wrap {
    padding-top: 80px;
}
</style>
